module.exports = __webpack_public_path__ + "img/image (3).934a2b18.svg";